// src/components/PrivateRoute-Cognito.jsx
// Cognito-based PrivateRoute to replace Auth0 implementation

import React from "react";
import { Navigate } from "react-router-dom";
import { useCognitoAuth } from "../aws-amplify-auth";
import LoadingScreen from "./parts/loadingScreen";

const PrivateRoute = ({ children }) => {
  const { loading, isAuthenticated, tokenLoading } = useCognitoAuth();

  React.useEffect(() => {
    // Only store redirect path if we're not already authenticated and not still loading
    if (!loading && !isAuthenticated && !tokenLoading) {
      localStorage.setItem('redirectAfterLogin', window.location.pathname);
    }
  }, [loading, isAuthenticated, tokenLoading]);

  // Show loading screen during authentication check or token loading
  if (loading || tokenLoading) return <LoadingScreen />;
  
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
};

export default PrivateRoute;
